var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { shouldSocketReconnect } from "../shouldSocketReconnect";
import { ConnectionNames } from "../../../contracts";
import { ConfigStore } from "../../stores";
let reconnects = 0;
let timeoutForReconnect;
/**
 * Create new function by binding the "additionalDelay" and "reconnectHandler" and pass by reference whenever you need.
 * @param additionalDelay delay to be incrementally applied when we start reconnecting too often
 * @param reconnectHandler function to execute when we need to reconnect
 * @param evt event object to determine if/when we need to reconnect
 */
export function connectionCloseHandler(additionalDelay, reconnectHandler, evt) {
    const [decision, delay] = shouldSocketReconnect(evt);
    if (decision) {
        clearTimeout(timeoutForReconnect);
        timeoutForReconnect = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            try {
                yield reconnectHandler();
                reconnects = 0;
                ConfigStore.config.tracking[ConnectionNames.sports].trackData({
                    message: "Reconnection Success",
                    clientAction: "RECONNECTION",
                });
            }
            catch (e) {
                reconnects += 1;
                ConfigStore.config.tracking[ConnectionNames.sports].trackError({
                    message: "Reconnection Failed",
                    clientAction: "RECONNECTION_ERROR",
                });
            }
        }), delay + (reconnects * additionalDelay));
    }
    return [decision, delay];
}
//# sourceMappingURL=connectionCloseHandler.js.map